export const initialInvoices = [
  { id: 'INV-2042', client: 'Acme Corp', project: 'Q3 Branding', amount: 12500, date: '2023-10-24', status: 'Paid' },
  { id: 'INV-2043', client: 'Globex UI', project: 'Website Redesign', amount: 8400, date: '2023-10-28', status: 'Pending' },
  { id: 'INV-2044', client: 'Stark Ind.', project: 'Video Asset', amount: 4200, date: '2023-10-15', status: 'Overdue' },
  { id: 'INV-2045', client: 'Wayne Ent', project: 'Retainer - Oct', amount: 5000, date: '2023-11-01', status: 'Draft' },
];

export const mockProjects = [
  { id: 1, name: 'Q3 Branding', client: 'Acme Corp', budget: 25000, spent: 18000, capacity: 85, status: 'Active', margin: '28%' },
  { id: 2, name: 'Website Redesign', client: 'Globex UI', budget: 15000, spent: 14500, capacity: 95, status: 'At Risk', margin: '3%' },
  { id: 3, name: 'Video Asset', client: 'Stark Ind.', budget: 8000, spent: 2000, capacity: 30, status: 'Active', margin: '75%' },
  { id: 4, name: 'Retainer - Oct', client: 'Wayne Ent', budget: 5000, spent: 1000, capacity: 20, status: 'Active', margin: '80%' },
];

export const mockPipeline = {
  'leads': [
    { id: 'l1', client: 'Initech', value: '$15k', type: 'Web App', note: 'Initial call scheduled' },
    { id: 'l2', client: 'Soylent', value: '$8k', type: 'Branding', note: 'Referral from Acme' }
  ],
  'pitching': [
    { id: 'p1', client: 'Umbrella Corp', value: '$45k', type: 'Full Stack OS', note: 'Proposal sent' }
  ],
  'negotiating': [
    { id: 'n1', client: 'Massive Dynamic', value: '$22k', type: 'Marketing Site', note: 'Drafting MSA' }
  ],
  'won': [
    { id: 'w1', client: 'Acme Corp', value: '$25k', type: 'Q3 Branding', note: 'Project kickoff' }
  ]
};

export const faqData = [
  {
    q: "What exactly does StudioLedger do for my agency?",
    a: "StudioLedger is an 'Agency OS' that bridges the gap between your CRM and your bank account. It tracks client pipelines, monitors project burn rates in real-time, and automates invoice tracking so you can focus on creative output rather than spreadsheets."
  },
  {
    q: "Is the data in this demo real?",
    a: "No, all data shown is simulated to demonstrate the platform's capabilities. No real financial transactions or private client data are processed in this demo environment."
  },
  {
    q: "How does the 'Team Capacity' metric work?",
    a: "It calculates the ratio of allocated hours across active projects against your team's total available bandwidth. Anything above 85% triggers an 'At Risk' warning for deliverable quality."
  },
  {
    q: "Can I integrate my existing banking tools?",
    a: "In the full version, StudioLedger connects via Plaid for automated reconciliation. This demo focuses on the UI/UX of the management dashboard."
  },
  {
    q: "Who is the 'Made by' credit for?",
    a: "StudioLedger was conceptualized and built by LingLink AI and DigLab AI as a premier demonstration of futuristic B2B SaaS design."
  }
];